import { render } from "./announceDesktopList.vue?vue&type=template&id=695b92f2"
import script from "./announceDesktopList.vue?vue&type=script&lang=js"
export * from "./announceDesktopList.vue?vue&type=script&lang=js"

import "./announceDesktopList.vue?vue&type=style&index=0&id=695b92f2&lang=scss"

import exportComponent from "../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__